// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/sass/style.scss
// module id = 11
// module chunks = 0